import React from 'react'
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import AppLayout from '../AppLayout';
import OrganizationUserSidebar from '../sidebars/OrganizationUserSidebar';

import OrganizationUserDashboard from '../organization_user/OrganizationUserDashboard';

import PermissionsPage from '../organization_user/permissions/PermissionsPage';
import NewPermissionPage from '../organization_user/permissions/NewPermissionPage';
import EditPermissionPage from '../organization_user/permissions/EditPermissionPage';
import RolesPage from '../organization_user/roles/RolesPage';
import NewRolePage from '../organization_user/roles/NewRolePage';
import EditRolePage from '../organization_user/roles/EditRolePage';
import UsersPage from '../organization_user/users/UsersPage';
import NewUserPage from '../organization_user/users/NewUserPage';
import EditUserPage from '../organization_user/users/EditUserPage';
import TagsPage from '../organization_user/tags/TagsPage';
import NewTagPage from '../organization_user/tags/NewTagPage';
import EditTagPage from '../organization_user/tags/EditTagPage';
import DocumentsPage from '../organization_user/documents/DocumentsPage';
import NewDocumentPage from '../organization_user/documents/NewDocumentPage';
import EditDocumentPage from '../organization_user/documents/EditDocumentPage';
import SearchDocumentationPage from '../organization_user/search_documentations/SearchDocumentationPage';

const OrganizationUserRoutes = () => {
  return (
    <Routes>

        {/* <Route
        path="/search-documentations"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <OrganizationUserDashboard />
            </AppLayout>
          </RequireAuth>
        }
      /> */}
     

     


  
      <Route
        path="/permissions"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <PermissionsPage />
            </AppLayout>
          </RequireAuth>
        }
      />

          <Route
        path="/permissions/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <NewPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/permissions/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <EditPermissionPage />
            </AppLayout>
          </RequireAuth>
        }
      />




      <Route
        path="/roles"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <RolesPage />
            </AppLayout>
          </RequireAuth>
        }
      />

          <Route
        path="/roles/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <NewRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/roles/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <EditRolePage />
            </AppLayout>
          </RequireAuth>
        }
      />

      <Route
        path="/users"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <UsersPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/users/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <NewUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/users/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <EditUserPage />
            </AppLayout>
          </RequireAuth>
        }
      />


  <Route
        path="/tags"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <TagsPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/tags/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <NewTagPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/tags/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <EditTagPage />
            </AppLayout>
          </RequireAuth>
        }
      /> 
      
       <Route
        path="/documents"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <DocumentsPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/documents/create"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <NewDocumentPage />
            </AppLayout>
          </RequireAuth>
        }
      />

       <Route
        path="/documents/edit/:id"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <EditDocumentPage />
            </AppLayout>
          </RequireAuth>
        }
      />


         <Route
        path="/search-documentations"
        element={
          <RequireAuth>
            <AppLayout sidebar={<OrganizationUserSidebar />}>
              <SearchDocumentationPage />
            </AppLayout>
          </RequireAuth>
        }
      />




       
    </Routes>
  )
}

export default OrganizationUserRoutes
